import { HumanQaReviewWorkbench } from '@/components/human-qa/HumanQaReviewWorkbench';
import { useAuth } from '@/contexts/AuthContext';
import { useTenantStore } from '@/stores/useTenantStore';

export default function HumanQaReviewWorkbenchPage() {
  const currentTenant = useTenantStore((state) => state.currentTenant);
  const { user, session } = useAuth();
  const reviewer =
    user?.email ||
    session?.user?.email ||
    user?.id ||
    session?.user?.id ||
    '';

  return (
    <HumanQaReviewWorkbench
      initialTenantId={currentTenant}
      defaultReviewer={reviewer}
    />
  );
}
